import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationMessenger } from '@dangl/angular-dangl-identity-client';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard implements CanActivate {
  private authenticationMessenger = inject(AuthenticationMessenger);


  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationMessenger.isAuthenticated;
  }
}
